import { Button, Heading, Paragraph } from "@digdir/designsystemet-react";
import { ArrowRightLeftIcon } from "@navikt/aksel-icons";
import { Link } from "@tanstack/react-router";
import { Trans, useTranslation } from "react-i18next";
import { useAuth } from "@/features/auth";
import {
  type SelskapSchema,
  useSelskaper,
} from "@/features/auth/SelskapContext";
import { UthevdTekst } from "@/features/auth/VelgSelskapPage";
import { GlobaltVarsel } from "@/features/varsler/GlobaltVarsel";

export const AvtaleHeader = () => {
  const { t } = useTranslation();
  const { account } = useAuth();
  const { active } = useSelskaper();

  return (
    <header className="w-full bg-balder-background-tinted border-b border-balder-border-subtle">
      <GlobaltVarsel />
      <div className="max-w-page px-5 sm:px-15 mx-auto py-12">
        <Heading data-size="lg" level={1} className="pb-6">
          {t("pages.avtaler.header.tittel", {
            navn: account?.navn || "velkommen!",
          })}
        </Heading>
        {active && active.organisasjonsnummer !== 0 ? (
          <LoggetInnMedSelskap selskap={active} />
        ) : (
          <LoggetInnUtenSelskap />
        )}
      </div>
    </header>
  );
};

const LoggetInnMedSelskap = ({ selskap }: { selskap: SelskapSchema }) => {
  return (
    <div className="flex">
      <Paragraph
        data-size="md"
        className="text-balder-text-subtle whitespace-pre-line pb-2 max-w-2xl"
      >
        <Trans
          i18nKey="pages.avtaler.header.beskrivelse-med-selskap"
          components={{
            Uthevd: <UthevdTekst />,
          }}
          values={{ selskapsNavn: selskap.navn }}
        />
      </Paragraph>
      <ByttSelskapLink />
    </div>
  );
};

const LoggetInnUtenSelskap = () => {
  const { t } = useTranslation();

  return (
    <div className="flex">
      <Paragraph
        data-size="md"
        className="text-balder-text-subtle whitespace-pre-line pb-2 max-w-2xl"
      >
        {t("pages.avtaler.header.beskrivelse-uten-selskap")}
      </Paragraph>
      <ByttSelskapLink />
    </div>
  );
};

const ByttSelskapLink = () => {
  const { t } = useTranslation();

  return (
    <Button variant="secondary" asChild>
      <Link to="/selskap">
        <ArrowRightLeftIcon
          fontSize={"1.5rem"}
          aria-label={t("pages.avtaler.header.bytt-selskap-knapp")}
        />
        <span className="hidden sm:inline-flex">
          {t("pages.avtaler.header.bytt-selskap-knapp")}
        </span>
      </Link>
    </Button>
  );
};
